// import * as React from 'react';
// import PropTypes from 'prop-types';
// import Avatar from '@mui/material/Avatar';
// import Button from '@mui/material/Button';
// import Divider from '@mui/material/Divider';
// import Drawer, { drawerClasses } from '@mui/material/Drawer';
// import Stack from '@mui/material/Stack';
// import Typography from '@mui/material/Typography';
// import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
// import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
// import MenuButton from './MenuButton';
// import MenuContent from './MenuContent';
// import { removeToken } from '../../Services/LocalStorageService'
// import { useNavigate } from 'react-router-dom';
// function SideMenuMobile({ open, toggleDrawer }) {
//   const navigate = useNavigate()
//   const handleLogout = () => {
//     removeToken()
//     navigate('/')
//   }
//   return (
//     <Drawer
//       anchor="right"
//       open={open}
//       onClose={toggleDrawer(false)}
//       sx={{
//         zIndex: (theme) => theme.zIndex.drawer + 1, // Ensures drawer is above default content
//         [`& .${drawerClasses.paper}`]: {
//           backgroundImage: 'none',
//           backgroundColor: 'background.paper',
//         },
//       }}
//     >
//       <Stack
//         sx={{
//           maxWidth: '70dvw',
//           height: '100%',
//         }}
//       >
//         {/* Sticky Header */}
//         <Stack
//           direction="row"
//           sx={{
//             p: 2,
//             pb: 0,
//             gap: 1,
//             position: 'sticky',
//             top: 0,
//             zIndex: (theme) => theme.zIndex.appBar + 1, // Ensure header stays above drawer content
//             backgroundColor: 'background.paper', // Fix background transparency
//           }}
//         >
//           <Stack
//             direction="row"
//             sx={{ gap: 1, alignItems: 'center', flexGrow: 1, p: 1 }}
//           >
//             <Avatar
//               sizes="small"
//               alt="Riley Carter"
//               src="/static/images/avatar/7.jpg"
//               sx={{ width: 24, height: 24 }}
//             />
//             <Typography component="p" variant="h6">
//               {localStorage.getItem('name')}
//             </Typography>
//           </Stack>

//           <MenuButton showBadge>
//             <NotificationsRoundedIcon />
//           </MenuButton>
//         </Stack>

//         <Divider />

//         <Stack sx={{ flexGrow: 1 }}>
//           <MenuContent />
//           <Divider />
//         </Stack>

//         <Stack sx={{ p: 2 }}>
//           <Button
//             variant="outlined"
//             fullWidth
//             startIcon={<LogoutRoundedIcon />}
//             onClick={handleLogout}
//           >
//             Logout
//           </Button>
//         </Stack>
//       </Stack>
//     </Drawer>

//   );
// }

// SideMenuMobile.propTypes = {
//   open: PropTypes.bool,
//   toggleDrawer: PropTypes.func.isRequired,
// };

// export default SideMenuMobile;



import * as React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer, { drawerClasses } from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import MenuButton from './MenuButton';
import MenuContent from './MenuContent';
import { removeToken } from '../../Services/LocalStorageService';
import { useNavigate } from 'react-router-dom';

function SideMenuMobile({ open, toggleDrawer }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    removeToken();
    navigate('/');
    toggleDrawer(false)();
  };

  // ✅ Menu item click होने पर drawer बंद करें
  const handleMenuItemClick = () => {
    toggleDrawer(false)();
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={toggleDrawer(false)}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        [`& .${drawerClasses.paper}`]: {
          backgroundImage: 'none',
          backgroundColor: 'background.paper',
        },
      }}
    >
      <Stack
        sx={{
          maxWidth: '70dvw',
          height: '100%',
        }}
      >
        {/* Sticky Header */}
        <Stack
          direction="row"
          sx={{
            p: 2,
            pb: 0,
            gap: 1,
            position: 'sticky',
            top: 0,
            zIndex: (theme) => theme.zIndex.appBar + 1,
            backgroundColor: 'background.paper',
          }}
        >
          <Stack
            direction="row"
            sx={{ gap: 1, alignItems: 'center', flexGrow: 1, p: 1 }}
          >
            <Avatar
              sizes="small"
              alt="Riley Carter"
              src="/static/images/avatar/7.jpg"
              sx={{ width: 24, height: 24 }}
            />
            <Typography component="p" variant="h6">
              {localStorage.getItem('name')}
            </Typography>
          </Stack>

          <MenuButton showBadge>
            <NotificationsRoundedIcon />
          </MenuButton>
        </Stack>

        <Divider />

        {/* ✅ MenuContent को onItemClick prop pass करें */}
        <Stack sx={{ flexGrow: 1 }}>
          <MenuContent onItemClick={handleMenuItemClick} />
          <Divider />
        </Stack>

        <Stack sx={{ p: 2 }}>
          <Button
            variant="outlined"
            fullWidth
            startIcon={<LogoutRoundedIcon />}
            onClick={handleLogout}
          >
            Logout
          </Button>
        </Stack>
      </Stack>
    </Drawer>
  );
}

SideMenuMobile.propTypes = {
  open: PropTypes.bool,
  toggleDrawer: PropTypes.func.isRequired,
};

export default SideMenuMobile;